import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { TextButtonComponent } from '@shared/button/text-button/text-button.component';
import { TimeAgoPipe } from '@pipes/time-ago.pipe';

@Component({
    selector: 'app-refresh-inbox',
    template: `<div>
        <span class="text-s color-gray13">
            @if (lastSyncDate) {
                <span>Last sync {{ lastSyncDate | timeAgo | async }}</span>
                <span class="color-gray6 ml-2">•</span>
            }
        </span>
        <app-text-button [dataQa]="dataQa" (clicked)="onClick()"
            >Refresh</app-text-button
        >
    </div>`,
    imports: [TextButtonComponent, TimeAgoPipe, AsyncPipe],
})
export class RefreshInboxComponent {
    @Input() lastSyncDate: Date | undefined;
    @Input() dataQa = '';
    @Output() clicked = new EventEmitter();

    onClick() {
        this.clicked.emit();
    }
}
